import { Serializable } from '@/models/core/serializable';

export class QuestionType implements Serializable<QuestionType> {
  questionTypeID: number;
  title: string;

  deserialize(input: any): QuestionType {
    this.questionTypeID = input.questionTypeID;
    this.title = input.title;
    return this;
  }
}
